import * as React from 'react';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import logo from '../../assets/images/avatar1.jpg';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    // backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
}));

export default function BadgeAvatars(props) {
  // Determine avatar source: Use DiceBear if seed is provided, otherwise use static logo.
  let avatarSrc;
  let altText = "User Avatar";
  if (props.seed) {
    avatarSrc = `https://api.dicebear.com/9.x/identicon/png?seed=${encodeURIComponent(props.seed)}`;
    altText = `Avatar for ${props.seed}`;
  } else {
    avatarSrc = logo; // Fallback to the static logo
    altText = "Default Badge Avatar";
  }

  return (
    <Stack direction="row" spacing={2}>
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
        style={{ color: '#44b700' }}
      >
        <Avatar alt={altText} src={avatarSrc} />
      </StyledBadge>

    </Stack>
  );
}
export function AvatarDynamic(props) {
  // Determine the avatar source URL
  let avatarSrc = logo; // Default fallback
  if (props.src) {
    avatarSrc = props.src;
  } else if (props.seed) {
    // Use DiceBear API (identicon style as an example)
    // You can change 'identicon' to other styles like 'avataaars', 'bottts', 'adventurer', etc.
    // See https://www.dicebear.com/styles/ for more options
    avatarSrc = `https://api.dicebear.com/9.x/identicon/png?seed=${encodeURIComponent(props.seed)}`;
  }

  return (
    <Stack direction="row" spacing={2}>
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
        color={props.color}
      >
        <Avatar alt={props.alt || "User Avatar"} src={avatarSrc} />
      </StyledBadge>

    </Stack>
  );
}